module.exports = __webpack_public_path__ + "static/media/education_2.251fe227.svg";